import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableHighlight,
  TouchableOpacity,
  View,
  Modal,
  Dimensions,
} from 'react-native';


import AgoraUIKit, { PropsInterface, layout } from 'agora-react-uikit';

import ImageView from 'react-native-image-view';
import { mstyles } from '../constants/MainStyles';
import common from '../common';
import FirebaseConsult from '../firebase/firebase_consult.js'

const styles = StyleSheet.create({
  consult: {
    flex: 1,
    backgroundColor: '#fff',
    flexDirection: 'row',
  },
  consultMobile: {
    flex: 1,
    backgroundColor: '#fff',
    flexDirection: 'column',
  },
  issueBox: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: 10,
    paddingRight: 40,
    paddingBottom: 20,
    paddingLeft: 40,
    width: '100%',
  },
  issueBoxMobile: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: 8,
    paddingRight: 20,
    paddingBottom: 15,
    paddingLeft: 20,
    width: '100%',
  },
  issueBox2: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  issueImage: {
    width: 47,
    height: 47,
    marginBottom: 5,
  },
  issueImageMobile: {
    width: 35,
    height: 35,
    marginBottom: 3,
  },
  issueText: {
    fontSize: 30,
    lineHeight: 32,
  },
  issueTextMobile: {
    fontSize: 22,
    lineHeight: 24,
  },
  issueText2: {
    fontSize: 16,
    lineHeight: 18,
  },
  issueText2Mobile: {
    fontSize: 14,
    lineHeight: 16,
  },
  vehicleBox: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 20,
    paddingRight: 40,
    paddingBottom: 15,
    paddingLeft: 40,
    borderTopColor: '#ceced2',
    borderTopWidth: 1,
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
  },
  vehicleBoxMobile: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 15,
    paddingRight: 20,
    paddingBottom: 12,
    paddingLeft: 20,
    borderTopColor: '#ceced2',
    borderTopWidth: 1,
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
  },
  vehicleText: {
    fontSize: 20,
    lineHeight: 22,
  },
  vehicleTextMobile: {
    fontSize: 16,
    lineHeight: 18,
  },
  vehicleText2: {
    fontSize: 18,
    lineHeight: 20,
  },
  vehicleText2Mobile: {
    fontSize: 15,
    lineHeight: 17,
  },
  profileBox: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 20,
    paddingRight: 40,
    paddingBottom: 15,
    paddingLeft: 40,
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
    marginBottom: 20,
  },
  profileBoxMobile: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 15,
    paddingRight: 20,
    paddingBottom: 12,
    paddingLeft: 20,
    borderBottomColor: '#ceced2',
    borderBottomWidth: 1,
    width: '100%',
    marginBottom: 15,
  },
  profileText: {
    fontSize: 16,
    lineHeight: 18,
  },
  profileTextMobile: {
    fontSize: 14,
    lineHeight: 16,
  },
  profileText2: {
    fontSize: 20,
    lineHeight: 22,
  },
  profileText2Mobile: {
    fontSize: 16,
    lineHeight: 18,
  },
  profileText3: {
    fontSize: 18,
    lineHeight: 20,
  },
  profileText3Mobile: {
    fontSize: 15,
    lineHeight: 17,
  },
  subtitle: {
    fontSize: 20,
    marginTop: 20,
  },
  text: {
    fontSize: 16,
    marginTop: 0,
    marginRight: 18,
    marginBottom: 0,
    marginLeft: 12,
    maxWidth: 200,
  },
  textMobile: {
    fontSize: 14,
    marginTop: 0,
    marginRight: 10,
    marginBottom: 0,
    marginLeft: 8,
    maxWidth: 150,
  },
  
  uploadBoxes: {
    marginTop: 10,
    marginBottom: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 300,
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadBox: {
    marginRight: 5,
    marginLeft: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  uploadButton: {
  },
  uploadImage: {
    width: 80,
    height: 60,
    alignSelf: 'center',
  },
  uploadAdd: {
    width: 80,
    height: 60,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: "#909097",
  },
  uploadButtonText: {
    textAlign: 'center',
    fontSize: 40,
    lineHeight: 45,
    fontFamily: 'nunito',
    color: '#909097',
    fontWeight: 500,
  },
  uploadBoxShadow: {
    width: 80,
    height: 60,
    backgroundColor: '#e2e0e0',
    position: 'absolute',
    top: 4,
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
  },
  modalTitle: {
    fontFamily: 'nunito',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  modalText: {
    fontFamily: 'nunito',
    fontSize: 16,
    marginBottom: 20,
  },
  modalButtons: {
    flexDirection: 'row',
  },
  modalButton: {
    backgroundColor: '#d02e25',
    borderRadius: 5,
    paddingVertical: 10,
    paddingHorizontal: 30,
    marginHorizontal: 10,
  },
  modalButtonText: {
    fontFamily: 'nunito',
    color: '#fff',
    fontSize: 16,
  },
});


export default class Screen extends Component {

  constructor(props) {
    console.log("consult: ",global.consult);
    console.log("channel: ",global.consult.channel);
    console.log("token: ",global.consult.token);
    super(props);

    this.state = {
      inCall: true,
      err: "",
      imageModalVisible: false,
      images: [],
      selectedImage: 0,
      showModal: false,
      windowWidth: Dimensions.get('window').width,
    };

    this.statusUnsubscribe = null; // Add reference for unsubscribe function

    let images = [];
    global.consult.media.map((item,index) => {
      //get width and height from uri
      Image.getSize(item, (width, height) => {
        images.push({
          source: { uri: item },
          width: width,
          height: height,
        });
      }, (error) => {
        console.log("error getting image size: ", error);
      });
    });
    this.state.images = images;

    // Set up listener for consultation status changes
    this.setupStatusListener();

  }

  componentDidMount() {
    this.dimensionsSubscription = Dimensions.addEventListener('change', this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: Dimensions.get('window').width });
  };

  setupStatusListener = () => {
    this.statusUnsubscribe = FirebaseConsult.watchForConsultationStatus((status, data) => {
      if (status === 'call ended' && this.state.inCall) {
        console.log("Consultation ended by other user");
        // Update global consultation data
        global.consult = data;
        // End the call locally without showing confirmation modal
        this.setState({ inCall: false });
        // Navigate to next screen
        this.props.navigation.navigate('T_Consult2');
      }
    });
  }

  componentWillUnmount() {
    // Clean up the listener when component unmounts
    if (this.statusUnsubscribe) {
      this.statusUnsubscribe();
    }
    // Clean up dimensions listener
    if (this.dimensionsSubscription) {
      this.dimensionsSubscription?.remove();
    }
  }

  handleEndCall = () => {
    this.setState({ showModal: true });
  }

  handleConfirmEndCall = () => {
    // Unsubscribe from status listener to prevent race condition
    if (this.statusUnsubscribe) {
      this.statusUnsubscribe();
      this.statusUnsubscribe = null;
    }
    
    global.consult.status = 'call ended';
    common.storeUserData()
    .then(() => FirebaseConsult.updateConsultInfo() )
    .then(() => {
      this.setState({ inCall: false, showModal: false });
      this.props.navigation.navigate('T_Consult2');
    });
  }

  handleCancelEndCall = () => {
    this.setState({ showModal: false });
  }

  setModalVisible = (visible, index) => {
    console.log("setModalVisible: ", visible, index);
    this.setState({
      imageModalVisible: visible,
      selectedImage: index || 0,
    });
  }

  render() {
    const isMobile = this.state.windowWidth <= 768;
    
    const agora = {
      connectionData: {
        appId: '77fcf06390ac4ca685fac7a2b37f3a81',
        channel: global.consult.channel,
        token: global.consult.token,
        layout: layout.grid,
      },
      rtcCallbacks: {
        EndCall: () => {
          this.handleEndCall();
        },
      },
      style: {
        localBtnContainer: {backgroundColor: '#17171a'}
      }
    };

    console.log(agora.connectionData.channel);
    console.log(agora.connectionData.token);
  

    return (
      <View style={isMobile ? styles.consultMobile : styles.consult} >
        <ImageView
          images={this.state.images}
          imageIndex={this.state.selectedImage}
          isVisible={this.state.imageModalVisible}
          renderFooter={(currentImage) => (<View><Text>Customer Image</Text></View>)}
          onClose={() => this.setModalVisible(false)}
        />

        <View style={isMobile ? {flex:2} : {flex:3}}>
          {(this.state.inCall) &&
            <AgoraUIKit rtcProps={agora.connectionData} callbacks={agora.rtcCallbacks} styleProps={agora.style}/>
          }
        </View>
        <View style={isMobile ? {flex:1} : {flex:1}}>
          <ScrollView showsVerticalScrollIndicator={false}>
            <View style={isMobile ? styles.issueBoxMobile : styles.issueBox}>
              <View style={styles.issueBox2}>
                <Image source={require('../assets/images/issue1.png')} style={isMobile ? styles.issueImageMobile : styles.issueImage} />
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.issueTextMobile : styles.issueText]}>
                  {global.consult.desc}
                </Text>
              </View>
            </View>

          
            <View style={isMobile ? styles.vehicleBoxMobile : styles.vehicleBox}>
              <Image source={require('../assets/images/vehicle1.png')} style={isMobile ? styles.issueImageMobile : styles.issueImage} />
              <View>
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.vehicleTextMobile : styles.vehicleText]} selectable={true}>
                  {global.consult.c_vehicle}
                </Text>
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.vehicleText2Mobile : styles.vehicleText2]} selectable={true}>
                  {global.consult.c_miles} miles
                </Text>
              </View>
            </View>

            <View style={isMobile ? styles.profileBoxMobile : styles.profileBox}>
              <Image source={require('../assets/images/profile1.png')} style={isMobile ? styles.issueImageMobile : styles.issueImage} />
              <View>
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.profileTextMobile : styles.profileText]} selectable={true}>
                  Requested by
                </Text>
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.profileText2Mobile : styles.profileText2]} selectable={true}>
                  {global.consult.c_name}
                </Text>
                <Text style={[mstyles.mfont, isMobile ? styles.textMobile : styles.text, isMobile ? styles.profileText3Mobile : styles.profileText3]} selectable={true}>
                  {common.timeDifference(global.consult.timeRequested)}
                </Text>
              </View>
            </View>

            <Text style={[mstyles.text, isMobile ? {fontSize: 14, marginLeft: 20, marginRight: 20} : {}]} selectable={true}>
              {global.consult.note}
            </Text>

            <View style={styles.uploadBoxes}>
              {global.consult.media.map((item,index) =>

              <View style={styles.uploadBox} key={index}>
                <View style={styles.uploadBoxShadow}></View>
                <TouchableHighlight
                    style={styles.uploadButton}
                    underlayColor={ 'rgba(0, 0, 0, 0.2)' }
                    onPress={() => this.setModalVisible(true, index)}
                >
                  <Image
                    source={{ uri: item }}
                    style={styles.uploadImage}
                  />
                </TouchableHighlight>
              </View>

              )}
            </View>
          </ScrollView>
        </View>
        <Modal
          visible={this.state.showModal}
          transparent={true}
          animationType='fade'
        >
          <View style={styles.modalContainer}>
            <View style={styles.modalContent}>
              <Text style={styles.modalTitle}>End Consultation</Text>
              <Text style={styles.modalText}>Are you sure you want to end the consultation?</Text>
              <View style={styles.modalButtons}>
                <TouchableOpacity style={styles.modalButton} onPress={this.handleConfirmEndCall}>
                  <Text style={styles.modalButtonText}>Yes</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.modalButton} onPress={this.handleCancelEndCall}>
                  <Text style={styles.modalButtonText}>No</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    );
  }

  static navigationOptions = {
    headerLeft: null,
    headerBackVisible: false,
  };
  
}